export default __webpack_public_path__ + "static/media/kids-room.17e48abd.jpg";